import React from 'react';
import helpIcon from 'icons/help-32.png';
import { updateHelpState } from 'store/storeValtio';

function HelpButton({helpType}) {

  function help()
  {
    //console.log('helpbutton', helpType);
    updateHelpState(true, helpType);
  }

  return (
    <div className=''>
        <img className='hover:cursor-pointer' src={helpIcon} onClick={()=>help()} alt=""/>
    </div>

  )
}

export default HelpButton